export default __webpack_public_path__ + "static/media/craon20.b270f2f0.jpg";